import { API_BASE_URL, isProduction, isDevelopment, isTest } from './env';

// API 前缀
export const API_PREFIX = '/api';

// 导出环境变量
export { API_BASE_URL, isProduction, isDevelopment, isTest };

// API 路由配置
export const ROUTES = {
  AUTH: {
    REGISTER: `${API_PREFIX}/auth/register`,
    LOGIN: `${API_PREFIX}/auth/login`,
    ME: `${API_PREFIX}/auth/me`,
    UPDATE_PROFILE: `${API_PREFIX}/auth/update-profile`,
    UPDATE_AVATAR: `${API_PREFIX}/auth/update-avatar`,
    AVATAR: (filename: string) => `${API_PREFIX}/auth/avatar/${filename}`,
    FORGOT_PASSWORD: `${API_PREFIX}/auth/forgot-password`,
    RESET_PASSWORD: `${API_PREFIX}/auth/reset-password`,
    VERIFY_EMAIL: `${API_PREFIX}/auth/verify-email`,
    REFRESH_TOKEN: `${API_PREFIX}/auth/refresh-token`,
    ADD_TRIAL_MEMBERSHIP: `${API_PREFIX}/auth/add-trial-membership`,
    RESEND_VERIFICATION: `${API_PREFIX}/auth/resend-verification`
  },
  
  PROJECTS: {
    BASE: `${API_PREFIX}/projects`,
    CREATE: `${API_PREFIX}/projects`,
    DETAIL: (id: string) => `${API_PREFIX}/projects/${id}`,
    DELETE: (id: string) => `${API_PREFIX}/projects/${id}`
  },
  
  STAGE_GOALS: {
    GET_ALL: (projectId: string) => `${API_PREFIX}/projects/${projectId}/stage-goals`,
    GET: (projectId: string, stage: number) => `${API_PREFIX}/projects/${projectId}/stage-goals/${stage}`,
    CREATE: `${API_PREFIX}/stage-goals`,
    UPDATE: (projectId: string, stage: number) => `${API_PREFIX}/projects/${projectId}/stage-goals/${stage}`
  },

  CHAT: {
    SEND: `${API_PREFIX}/chat`,
    HISTORY: (projectId: string) => `${API_PREFIX}/chat/history/${projectId}`,
    ARCHIVE: (chatId: string) => `${API_PREFIX}/chat/${chatId}/archive`
  }
};

// 辅助函数：获取完整的 API URL
export const getFullApiUrl = (path: string): string => {
  return `${API_BASE_URL}${path}`;
};

// 辅助函数：获取带参数的完整 API URL
export const getFullApiUrlWithParams = (path: string, params: Record<string, string | number>): string => {
  const url = new URL(`${API_BASE_URL}${path}`);
  Object.entries(params).forEach(([key, value]) => {
    url.searchParams.append(key, String(value));
  });
  return url.toString();
}; 